export function getHtmlFromString(content: string): any {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    return doc.body;
}

export function processHtml(content: any): HTMLElement {
    const specificItemArrow = '↑';
    const specificItemArrowAscii = '&uarr;';
    const customArrow = 's1t2r3e4l5i6c7a';
    content = content.replaceAll(specificItemArrow, customArrow);
    content = content.replaceAll(specificItemArrowAscii, customArrow);

    const html = getHtmlFromString(content);
    const allLiItems = html.getElementsByTagName('li');
    for (const item of allLiItems) {
        if (item.innerHTML.indexOf(customArrow) >= 0) {
            item.innerHTML = item.innerHTML.replace(customArrow, '');
            item.closest('ul').className += 'noMarginTopUL';
        }
    }

    const allParagraphs = html.getElementsByTagName('p');
    for (const item of allParagraphs) {
        if (item.innerHTML.indexOf(customArrow) >= 0) {
            item.innerHTML = item.innerHTML.replace(customArrow, '');
            item.className += 'noMarginTopP';
        }
    }

    const allLinks = html.getElementsByTagName('a');
    for (const item of allLinks) {
        item.setAttribute('target', '_blank');
    }

    return html;
}

export function parseUnitTextForDisplaying(text: string): string {
    const customBR = '[br]';
    let processedText = text.replace(/<br>/g, customBR);
    const html = processHtml(processedText);
    return html.innerHTML.replace(/\[br\]/g, '<br>');
}
